import { useLazyQuery } from '@apollo/client'
import axios from 'axios'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { FaInbox, FaSort } from 'react-icons/fa'
import { IoMdRefresh, IoMdSearch } from 'react-icons/io'
import { GET_FILTERED_CAB_BOOKING_BY_OWNER_ID } from '../../Services/cabggl'
import { toast } from 'react-toastify'
import DatePicker2 from '../../Components/Input/DatePicker2'
import Spinner from '../../Components/Spinner'
import MobileAllocate from './Popup/mobileAllocate'
import { getDecryptedSessionStorageVariable } from '../../utils/encryptStorage'

const yesterday = new Date()
yesterday.setDate(yesterday.getDate() - 1)
export const yesterdayFormatted = yesterday.toISOString().split('T')[0]
export function getRelievingDate(user) {
  const offDutyHistory = user?.history?.filter(
    (h) => h?.status === 'Off Duty' && h?.updatedDate
  )
  if (offDutyHistory?.length > 0) {
    return moment(offDutyHistory[0]?.updatedDate).format('lll')
  }
  return moment(user?.tentativeRelievingDate).format('lll')
}
export function getReportingDate(user) {
  const startDutyHistory = user?.history?.filter(
    (h) => h?.status === 'Start Duty' && h?.updatedDate
  )
  if (startDutyHistory?.length > 0) {
    return moment(startDutyHistory[0]?.updatedDate)
  }
  return moment(user?.tentativeReportingDate)
}

export default function CabBookingReport() {
  const fleetId = getDecryptedSessionStorageVariable('fleetId')
  const getYesterday = () => {
    return moment().subtract(1, 'day')
  }
  const [selectedSize, setSelectedSize] = useState(500)
  const [pageNumber, setPageNumber] = useState(1)
  const [total, setTotal] = useState(0)
  const [sortedField, setSortedField] = useState(null)
  const [sortOrder, setSortOrder] = useState('')
  const [startDate, setStartDate] = useState(null)
  const [endDate, setEndDate] = useState(null)
  const [addBooking, setAddBooking] = useState(false)
  const [data, setData] = useState([])
  const [selectedBooking, setSelectedBooking] = useState(null)
  const [updateCabBooking, setUpdateCabBooking] = useState(false)
  const [searchValues, setSearchValues] = useState({
    bookingId: '',
    customerName: '',
    dutyType: '',
    tripType: '',
    reportingLocation: '',
    status: '',
    driverName: '',
    driverRating: '',
    relievingDate: '',
    totalAmount: '',
    transmissionType: '',
    otp: '',
  })

  const [getBookings, { loading: loadingoffilterbooking }] = useLazyQuery(
    GET_FILTERED_CAB_BOOKING_BY_OWNER_ID
  )

  const handleAddBooking = () => {
    setAddBooking(true)
  }

  const handleSort = (field) => {
    if (!field) {
      return
    }

    if (field === sortedField) {
      setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc')
    } else {
      setSortedField(field)
      setSortOrder('asc')
    }
  }

  const filterDataByDateRange = async () => {
    const yesterdayDate = getYesterday()
    await getBookings({
      variables: {
        filterCabInput: {
          fromDate: startDate ? new Date(startDate) : new Date(yesterdayDate),
          toDate: endDate ? new Date(endDate) : null,
          fleetOwnerId: fleetId,
        },
        pageNumber,
        pageSize: selectedSize,
      },
      fetchPolicy: 'no-cache',
    })
      .then((res) => {
        setData([...res.data?.getFilteredCabBookingByFleetOwnerId?.cabBooking])
        setTotal(res.data?.getFilteredCabBookingByFleetOwnerId?.total)
        setSelectedBooking(
          (prev) =>
            res.data?.getFilteredCabBookingByFleetOwnerId?.cabBooking?.filter(
              (s) => s?.id === prev?.id
            )?.[0]
        )
      })
      .catch((err) => {
        toast.error('Something Went Wrong')
      })
  }

  const handleDateChange = (e, setDate) => {
    setDate(moment(e.target.value).format('YYYY-MM-DD'))
  }

  useEffect(() => {
    filterDataByDateRange()
  }, [])

  return (
    <div className="w-full  h-full bg-white p-4 shadow rounded-md text-start">
      <div className="w-full flex  text-start sm:flex-row sm:justify-between sm:items-start gap-4 sm:gap-0">
        <div className="text-stone-500 text-xl font-bold mb-4">
          Live Booking
        </div>
      </div>
      <div>
        <div className="mt-5 flex flex-col sm:flex-row gap-4 sm:justify-between sm:items-end">
          <DatePicker2
            value={moment(startDate).format('YYYY-MM-DD')}
            onChange={(e) => handleDateChange(e, setStartDate)}
            labelValue="Start Date"
            name="startDate"
            minDate={yesterdayFormatted}
          />
          <DatePicker2
            value={moment(endDate).format('YYYY-MM-DD')}
            onChange={(e) => handleDateChange(e, setEndDate)}
            labelValue="End Date"
            name="endDate"
          />
          <div className="flex sm:flex-row gap-2 sm:gap-4 mt-4 sm:mt-0">
            <button
              onClick={() => filterDataByDateRange()}
              className="bg-sky-500 px-4 py-1.5 rounded text-xs font-semibold flex items-center gap-2 text-white border-[#5899eb] hover:opacity-80"
            >
              <IoMdSearch size={20} />
              Search
            </button>
            <button
              onClick={() => filterDataByDateRange()}
              className="bg-sky-500 px-4 py-1.5 rounded text-xs font-semibold flex items-center gap-2 text-white border-[#5899eb] hover:opacity-80"
            >
              <IoMdRefresh size={20} />
              Refresh
            </button>
          </div>
        </div>
      </div>
      <div className="mt-4 w-full overflow-scroll h-[70vh]">
        {loadingoffilterbooking ? (
          <Spinner />
        ) : (
          <table className="w-full text-sm text-left rtl:text-right text-gray-500 border-collapse border border-gray-300">
            <thead className="text-xs text-gray-700 uppercase bg-gray-50 sticky top-0 z-10">
              <tr>
                <th scope="col" className="px-2 py-3 border border-#cedbe2-800">
                  <div className="flex items-center">
                    Booking Id
                    {/* <FaSort onClick={() => handleSort('id')} /> */}
                  </div>
                </th>

                <th scope="col" className="px-2 py-3 border border-#cedbe2-800">
                  <div className="flex gap-1 items-center">
                    Travel Type
                    {/* <FaSort onClick={() => handleSort('tripType')} /> */}
                  </div>
                </th>
                <th scope="col" className="px-2 py-3 border border-#cedbe2-800">
                  <div className="flex gap-1 items-center">
                    Trip Type
                    {/* <FaSort onClick={() => handleSort('transmissionType')} /> */}
                  </div>
                </th>
                <th scope="col" className="px-2 py-3 border border-#cedbe2-800">
                  <div className="flex gap-1 items-center">
                    Reporting Date Time
                    {/* <FaSort onClick={() => handleSort('reportingDate')} /> */}
                  </div>
                </th>
                <th scope="col" className="px-2 py-3 border border-#cedbe2-800">
                  <div className="flex gap-1 items-center">
                    Relieving Date Time
                    {/* <FaSort
                      onClick={() => handleSort('tentativeRelievingDate')}
                    /> */}
                  </div>
                </th>
                <th
                  scope="col"
                  className="px-2 py-3 border border-#cedbe2-800 "
                >
                  <div className="flex gap-1 items-center">
                    Status
                    {/* <FaSort onClick={() => handleSort('status')} /> */}
                  </div>
                </th>
                <th
                  scope="col"
                  className="px-2 py-3 border border-#cedbe2-800 "
                >
                  <div className="flex gap-1 items-center">
                    Reporting Location
                    {/* <FaSort onClick={() => handleSort('status')} /> */}
                  </div>
                </th>
                <th
                  scope="col"
                  className="px-2 py-3 border border-#cedbe2-800 "
                >
                  <div className="flex gap-1 items-center">
                    Releaving Location
                    {/* <FaSort onClick={() => handleSort('status')} /> */}
                  </div>
                </th>
                <th scope="col" className="px-2 py-3 border border-#cedbe2-800">
                  <div className="flex gap-1 items-center">
                    Fleet Owner Name
                    {/* <FaSort onClick={() => handleSort(`driverId.firstName`)} /> */}
                  </div>
                </th>
                <th scope="col" className="px-2 py-3 border border-#cedbe2-800">
                  <div className="flex gap-1 items-center">
                    Car No
                    {/* <FaSort onClick={() => handleSort(`driverId.firstName`)} /> */}
                  </div>
                </th>
                <th scope="col" className="px-2 py-3 border border-#cedbe2-800">
                  <div className="flex gap-1 items-center">
                    Car Type
                    {/* <FaSort onClick={() => handleSort(`driverId.firstName`)} /> */}
                  </div>
                </th>
                <th scope="col" className="px-2 py-3 border border-#cedbe2-800">
                  <div className="flex gap-1 items-center">
                    Driver Name
                    {/* <FaSort onClick={() => handleSort(`driverId.firstName`)} /> */}
                  </div>
                </th>
                <th scope="col" className="px-2 py-3 border border-#cedbe2-800">
                  <div className="flex gap-1 items-center">
                    Payment Method
                    {/* <FaSort onClick={() => handleSort(`driverId.firstName`)} /> */}
                  </div>
                </th>

                <th scope="col" className="px-2 py-3 border border-#cedbe2-800">
                  <div className="flex gap-1 items-center">
                    Driver Share
                    {/* <FaSort
                      onClick={() => handleSort('estimatedDriverShare')}
                    /> */}
                  </div>
                </th>
                <th
                  scope="col"
                  className="px-2 py-3 border border-#cedbe2-800 "
                >
                  <div className="flex gap-1 items-center">
                    Id Share
                    {/* <FaSort onClick={() => handleSort('idShare')} /> */}
                  </div>
                </th>

                <th scope="col" className="px-2 py-3 border border-#cedbe2-800">
                  <div className="flex gap-1 items-center">
                    OTP
                    {/* <FaSort onClick={() => handleSort('otp')} /> */}
                  </div>
                </th>
              </tr>
            </thead>
            <tbody className=" w-full border border-#cedbe2-800 ">
              {data ? (
                data?.slice().map((booking, index) => (
                  <tr
                    className={`${
                      booking?.customerId?.id === booking?.createdBy
                        ? 'bg-[#f3c74a]'
                        : booking?.paymentMethod === 'D'
                        ? 'bg-[#cedbe2]'
                        : booking?.paymentMethod === 'O'
                        ? 'bg-[#8ab8f1]'
                        : ''
                    } border-b`}
                    key={index}
                    onClick={() => {
                      if (booking?.status === 'Paid') {
                        toast.success('Booking paid already')
                        return
                      }
                      setUpdateCabBooking(true)
                      setSelectedBooking(booking)
                    }}
                  >
                    <td className="px-2 py-4 border border-#cedbe2-800">
                      {booking?.id}
                    </td>
                    <td className="px-2 py-4 border border-#cedbe2-800">
                      {booking?.travelType}
                    </td>
                    <td className="px-2 py-4 border border-#cedbe2-800">
                      {booking?.tripType}
                    </td>
                    <td className="px-2 py-4 border border-#cedbe2-800">
                      {/* {moment(
                        getReportingDate(booking.history.reportingDate)
                      ).format('LLL')} */}
                      {moment(booking.tentativeReportingDate).format('LLL')}
                    </td>
                    <td className="px-2 py-4 border border-#cedbe2-800">
                      {/* {getRelievingDate(booking)} */}
                      {moment(booking.tentativeRelievingDate).format('LLL')}
                    </td>
                    <td className="px-2 py-4 border border-#cedbe2-800">
                      {booking?.status === 'Start Duty'
                        ? 'On Duty'
                        : booking?.status === 'Off Duty'
                        ? 'Done'
                        : booking?.status}
                    </td>
                    <td className="px-2 py-4 border border-#cedbe2-800">
                      {booking?.pickAddress?.address}
                    </td>
                    <td className="px-2 py-4 border border-#cedbe2-800">
                      {booking?.dropAddress?.address}
                    </td>
                    <td className="px-2 py-4 border border-#cedbe2-800 cursor-pointer">
                      {`${booking.fleetOwnerId?.firstName ?? ''} ${
                        booking.fleetOwnerId?.lastName ?? ''
                      } ${
                        booking.fleetOwnerId?.mobileNumber
                          ? `(${booking.fleetOwnerId.mobileNumber})`
                          : ''
                      }`.trim()}
                    </td>
                    <td className="px-2 py-4 border border-#cedbe2-800 ">
                      {booking.cabId?.variant && booking.cabId?.carNo
                        ? `${booking.cabId?.variant ?? ''} (${
                            booking.cabId?.carNo ?? ''
                          })`.trim()
                        : ''}
                    </td>
                    <td className="px-2 py-4 border border-#cedbe2-800 ">
                      {booking?.carType}
                    </td>
                    <td className="px-2 py-4 border border-#cedbe2-800 cursor-pointer">
                      {`${booking.driverId?.firstName ?? ''} ${
                        booking.driverId?.lastName ?? ''
                      } ${
                        booking.driverId?.mobileNumber
                          ? `(${booking.driverId.mobileNumber})`
                          : ''
                      }`.trim()}
                    </td>
                    <td className="px-2 py-4 border border-#cedbe2-800">
                      {booking?.paymentMethod === 'D'
                        ? 'Cash By Driver'
                        : booking?.paymentMethod === 'O'
                        ? 'Cash By Office'
                        : ''}
                    </td>
                    <td className="px-2 py-4 border border-#cedbe2-800">
                      ₹
                      {parseFloat(booking?.faresId?.fleetFares?.total).toFixed(
                        2
                      )}
                    </td>
                    <td className="px-2 py-4 border border-#cedbe2-800">
                      ₹{parseFloat(booking.faresId?.idFares?.total).toFixed(2)}
                    </td>
                    <td className="px-2 py-4 border border-#cedbe2-800">
                      {booking?.otp ? booking?.otp : ''}
                    </td>
                  </tr>
                ))
              ) : (
                <tr className="bg-white">
                  <td
                    className="px-2 py-4 border border-#cedbe2-800 text-center"
                    colSpan="13"
                  >
                    <div className="flex justify-center items-center h-16">
                      <FaInbox className="mr-2" />
                      No data found
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        )}
      </div>
      {updateCabBooking && (
        <MobileAllocate
          isOpen={updateCabBooking}
          onClose={setUpdateCabBooking}
          refetch={filterDataByDateRange}
          selectedBooking={selectedBooking}
        />
      )}
    </div>
  )
}
